// extracted by mini-css-extract-plugin
export var sbShowMain = "pages-module--sb-show-main--K4O9V";
export var notFound = "pages-module--notFound--MbKaC";
export var imageContainer = "pages-module--imageContainer--2kvwM";
export var backHomeButton = "pages-module--backHomeButton--1XMPL";